import { create } from 'zustand';

interface BoardState {
  activeStatusId: string | null;
  draggedTaskId: string | null;
  viewMode: 'board' | 'list';

  setActiveStatusId: (statusId: string | null) => void;
  setDraggedTaskId: (taskId: string | null) => void;
  setViewMode: (mode: 'board' | 'list') => void;
}

export const useBoardStore = create<BoardState>((set) => ({
  activeStatusId: null,
  draggedTaskId: null,
  viewMode: 'board',

  setActiveStatusId: (statusId) => set({ activeStatusId: statusId }),
  setDraggedTaskId: (taskId) => set({ draggedTaskId: taskId }),
  setViewMode: (mode) => set({ viewMode: mode }),
}));
